import { render, staticRenderFns } from "./CategoriaCriteriosElegibilidade.vue?vue&type=template&id=11ff5e94"
import script from "./CategoriaCriteriosElegibilidade.vue?vue&type=script&lang=js"
export * from "./CategoriaCriteriosElegibilidade.vue?vue&type=script&lang=js"
import style0 from "./CategoriaCriteriosElegibilidade.vue?vue&type=style&index=0&id=11ff5e94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports